module.exports = __webpack_public_path__ + "static/media/ic_ads_manage.a5d77aa8.svg";